/* global gsap, ScrollTrigger */
// Timeline Scroll Section
// ul.ps_timeline_ul {
//   li.lineli {
// --------------------------------------------------------------
$(".ps_timeline").each(function () {
  var $timeline = $(this),
    items = $timeline.find("li.lineli"),
    timelineHeight = $timeline.find("ul.ps_timeline_ul").height(),
    greyLine = $timeline.find('.default-line'),
    lineToDraw = $timeline.find('.draw-line');

  // sets the height that the greyLine (.default-line) should be according to `.timeline ul` height
  greyLine.css({
    'height': $timeline.height() + 'px'
  });
  // run this function only if draw line exists on the page
  if (lineToDraw.length) {
    $(window).on('scroll', function () {

      // Need to constantly get '.draw-line' height to compare against '.default-line'
      var redLineHeight = lineToDraw.height(),
        greyLineHeight = greyLine.height(),
        windowDistance = $(window).scrollTop(),
        windowHeight = $(window).height() / 2,
        timelineDistance = $timeline.offset().top;

      if (windowDistance >= timelineDistance - windowHeight) {
        var line = windowDistance - timelineDistance + windowHeight;

        if (line <= greyLineHeight) {
          lineToDraw.css({
            'height': line + 20 + 'px'
          });
        }
      }

      // This takes care of adding the class in-view to the li:before items
      var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
      items.each(function (index) {
        var circlePosition = $(this).offset();

        if (bottom > circlePosition.top) {
          $(this).addClass('in-view');
        } else {
          $(this).removeClass('in-view');
        }
      });
    });
  }
});


// gsap.registerPlugin(ScrollTrigger);
// // Select every timeline container on the page
// document.querySelectorAll('.ps_timeline_horizontal').forEach(container => {

//   // Find the inner UL for this specific instance
//   const list = container.querySelector('.ps_timeline_ul');
//   list.style.setProperty('--custom-width', list.scrollWidth + 'px');

//   console.log(list.scrollWidth,'sssssss', container.clientWidth)
//   if (!list) return;

//   // Setup horizontal scroll animation for this instance
//   gsap.to(list, {
//     x: () => -(list.scrollWidth - container.clientWidth),
//     ease: "none",
//     scrollTrigger: {
//       trigger: container,
//       start: "top top",
//       end: () => "+=" + (list.scrollWidth - container.clientWidth),
//       pin: container,
//       scrub: true,
//       invalidateOnRefresh: true
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', function () {

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('.ps_timeline_horizontal').forEach(container => {

    const list = container.querySelector('.ps_timeline_ul');
    if (!list) return;

    // Inject circle tip element
    const tip = document.createElement("div");
    tip.classList.add("progress-tip");
    list.appendChild(tip);

    // Full-width line
    list.style.setProperty('--custom-width', list.scrollWidth + 'px');

    const maxScrollX = list.scrollWidth - container.clientWidth;

    gsap.to(list, {
      x: () => -maxScrollX,
      ease: "none",
      scrollTrigger: {
        trigger: container,
        start: "top top",
        end: () => "+=" + maxScrollX,
        pin: container,
        scrub: true,
        invalidateOnRefresh: true,

        onUpdate: (self) => {
          const progress = self.progress;
          const progressedWidth = progress * list.scrollWidth;

          list.style.setProperty('--progress-width', progressedWidth + 'px');

          // move the circle to the tip
          tip.style.left = progressedWidth + 'px';
        }
      }
    });
  });
});

